import React, { Component } from "react";
import { Button, Row, Col, InputGroup, Alert } from "reactstrap";
import { LoadingModal } from "./LoadingModal";
import { FetchData, FetchFile } from "./utils/DataFetch";
import { GetCookie, Timeout, openFileInNewTab } from "./utils/Common";

import { saveAs } from "file-saver";
import { InterpreterPaymentTableDefault } from "./InterpreterPaymentsTableDefault";

export class InterpreterPayment extends Component {
  static displayName = InterpreterPayment.name;

  constructor(props) {
    super(props);
    this.state = {
      interpreterPaymentList: [],
      loading: false,
      fetchingData: false,
      modal: false,
      alert: {
        color: "info",
        message: "",
        isOpen: false,
      },
      model: {
        EventType: "insert",
        JobID: null,
        JobNum: null,
        JobDate: null,
        IntId: null,
        InterpreterFirstName: "",
        InterpreterLastName: "",
        DBA: "",
        BankAccount: "",
        BankRoute: "",
        JobTotal: "",
      },
      searchModel: {
        StartDate: "",
        EndDate: "",
        StartCheckNumber: "",
        CommitToDB: false,
        ContractFlg: null,
        InHouseFlg: false,
      },
    };
    this.user = JSON.parse(GetCookie("user"));
    this.clickCount = 0;
    this.singleClickTimer = "";

    this.renderInterpreterPaymentTable =
      this.renderInterpreterPaymentTable.bind(this);
    //
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleSearchEvent = this.handleSearchEvent.bind(this);
    //
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.exportELANachaTXT = this.exportELANachaTXT.bind(this);
    this.exportPayPal = this.exportPayPal.bind(this);
    this.exportEDD1099TXT = this.exportEDD1099TXT.bind(this);
    this.printPhysicalCheck = this.printPhysicalCheck.bind(this);
    this.exportInHousePayment = this.exportInHousePayment.bind(this);
    this.sendInterpreterPaymentNotifications =
      this.sendInterpreterPaymentNotifications.bind(this);
  }

  componentDidMount() {}

  handleSaveEventSuccess(alert) {
    this.setState(
      {
        modal: alert.modal,
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });
        }, Timeout(alert.message));
        this.populateInterpreterData();
      }
    );
  }

  handleSearchEvent(alert) {
    this.setState(
      {
        modal: alert.modal,
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });
        }, Timeout(alert.message));
      }
    );
  }

  handleSearchChange(e) {
    let model = { ...this.state.searchModel };
    if (e.target.name === "Inactive") {
      model[e.target.name] = !this.state.searchModel.Inactive;
    } else if (e.target.type === "checkbox") {
      if (e.target.name === "InHouseFlg") {
        model[e.target.name] = e.target.checked ? true : false;
      } else {
        model[e.target.name] = e.target.checked;
      }
    } else model[e.target.name] = e.target.value;

    this.setState({ searchModel: model });
  }

  handleKeyDown(e) {
    if (e.key === "Enter") {
      this.populateInterpreterPaymentData();
    }
  }

  async populateInterpreterPaymentData() {
    if (
      !this.state.searchModel.StartDate ||
      !this.state.searchModel.EndDate
    ) {
      this.handleSearchEvent({
        message: "Please enter start date and end date.",
        modal: true,
        color: "warning",
      });
    } else {
      this.setState({ fetchingData: true });

      FetchData(
        "/get_InterpreterPayments",
        "POST",
        this.user.token,
        this.state.searchModel
      ).then((data) => {
        this.setState({
          interpreterPaymentList: data,
          loading: false,
          fetchingData: false,
        });
      });
    }
  }

  async addLeadingZeros(num, totalLength) {
    return String(num).padStart(totalLength, "0");
  }

  async exportELANachaTXT() {
    let body = {
      StartDate: this.state.searchModel.StartDate,
      EndDate: this.state.searchModel.EndDate,
      CreatedByUserId: this.user.userid,
    };

    var currentDate = new Date();
    var currentMonth = currentDate.getMonth() + 1;
    var currentMonthWithZeros = "";
    currentMonthWithZeros = String(currentMonth).padStart(2, "0");

    var fileName =
      "ELANacha" +
      currentMonthWithZeros.toString() +
      currentDate.getDate().toString() +
      currentDate.getFullYear().toString() +
      ".txt";

    await FetchFile("/rptELANacha", "POST", this.user.token, body).then(
      (blob) => {
        if (!blob || blob.size === 0) {
          this.handleSearchEvent({ color: 'warning', message: 'No file returned.', modal: false });
          return;
        }
        saveAs(blob, fileName);
      }
    );
  }

  async exportPayPal() {
    let body = {
      StartDate: this.state.searchModel.StartDate,
      EndDate: this.state.searchModel.EndDate,
      CreatedByUserId: this.user.userid,
    };

    var currentDate = new Date();
    var currentMonth = currentDate.getMonth() + 1;
    var currentMonthWithZeros = "";
    currentMonthWithZeros = String(currentMonth).padStart(2, "0");

    var fileName =
      "PayPal" +
      currentMonthWithZeros.toString() +
      currentDate.getDate().toString() +
      currentDate.getFullYear().toString() +
      ".txt";

    await FetchFile("/rptPayPal", "POST", this.user.token, body).then(
      (blob) => {
        if (!blob || blob.size === 0) {
          this.handleSearchEvent({ color: 'warning', message: 'No file returned.', modal: false });
          return;
        }
        saveAs(blob, fileName);
      }
    );
  }

  async exportEDD1099TXT() {
    let body = {
      StartDate: this.state.searchModel.StartDate,
      EndDate: this.state.searchModel.EndDate,
      CreateByUserId: this.user.userid,
    };

    var fileName =
      "eddreport" /*+ currentMonthWithZeros.toString() + currentDate.getDate().toString() + currentDate.getFullYear().toString()*/ +
      ".txt";

    await FetchFile("/rptEDD1099", "POST", this.user.token, body).then(
      (blob) => {
        if (!blob || blob.size === 0) {
          this.handleSearchEvent({ color: 'warning', message: 'No file returned.', modal: false });
          return;
        }
        saveAs(blob, fileName);
      }
    );
  }

  async printPhysicalCheck() {
    let body = {
      StartCheckNumber: this.state.searchModel.StartCheckNumber,
      StartDate: this.state.searchModel.StartDate,
      EndDate: this.state.searchModel.EndDate,
      CommitToDB: this.state.searchModel.CommitToDB,
    };

    var currentDate = new Date();
    var currentMonth = currentDate.getMonth() + 1;
    var currentMonthWithZeros = "";
    currentMonthWithZeros = String(currentMonth).padStart(2, "0");

    var fileName =
      "InterpreterChecks" +
      currentMonthWithZeros.toString() +
      currentDate.getDate().toString() +
      currentDate.getFullYear().toString() +
      ".pdf";

    await FetchFile("/printphysicalcheck", "POST", this.user.token, body).then(
      (blob) => {
        if (!blob || blob.size === 0) {
          this.handleSearchEvent({ color: 'warning', message: 'No file returned.', modal: false });
          return;
        }
        openFileInNewTab(blob, fileName);
      }
    );
  }

  async exportInHousePayment() {
    let body = {
      StartCheckNumber: this.state.searchModel.StartCheckNumber,
      StartDate: this.state.searchModel.StartDate,
      EndDate: this.state.searchModel.EndDate,
      CommitToDB: this.state.searchModel.CommitToDB,
    };

    var currentDate = new Date();
    var currentMonth = String(currentDate.getMonth() + 1).padStart(2, "0");
    var fileName =
      "InHousePayment" +
      currentMonth +
      currentDate.getDate().toString() +
      currentDate.getFullYear().toString() +
      ".csv";

    await FetchFile("/exportinhousepayment", "POST", this.user.token, body).then(
      (blob) => {
        if (!blob || blob.size === 0) {
          this.handleSearchEvent({ color: "warning", message: "No file returned.", modal: false });
          return;
        }
        saveAs(blob, fileName);
      }
    );
  }

  async sendInterpreterPaymentNotifications() {
    if (
      !this.state.searchModel.StartDate ||
      !this.state.searchModel.EndDate
    ) {
      this.handleSearchEvent({
        message: "Please enter start date and end date.",
        modal: true,
        color: "warning",
      });
      return;
    }

    this.setState({ fetchingData: true });

    FetchData(
      "/sendInterpreterPaymentEmails",
      "POST",
      this.user.token,
      this.state.searchModel
    )
      .then((data) => {
        const message =
          (data && data.message) || (typeof data === "string" ? data : "Done");
        const isSuccess =
          message === "Success" || data?.success === true || data === "OK";
        this.handleSearchEvent({
          message,
          modal: false,
          color: isSuccess ? "success" : "warning",
        });
      })
      .catch(() => {
        this.handleSearchEvent({
          message: "Failed to send interpreter payment notifications.",
          modal: false,
          color: "warning",
        });
      })
      .finally(() => {
        this.setState({ fetchingData: false });
      });
  }

  renderInterpreterPaymentTable() {
    return (
      <InterpreterPaymentTableDefault
        interpreterPayments={this.state.interpreterPaymentList}
        onGridReady={this.onGridReady}
        onColumnResized={this.onColumnResized}
        autoSizeUnspecifiedColumns={this.autoSizeUnspecifiedColumns}
        adjustHeaderHeight={this.adjustHeaderHeight}
      />
    );
  }

  render() {
    let contents = this.state.loading ? (
      <p>
        <em>Loading...</em>
      </p>
    ) : (
      this.renderInterpreterPaymentTable()
    );

    return (
      <div>
        <center>
          <Alert
            color={this.state.alert.color}
            isOpen={this.state.alert.isOpen}
          >
            {this.state.alert.message}
          </Alert>
        </center>
        <h5 id="tabelLabel">Interpreter Payments</h5>
        <Row>
          <Col>
            <InputGroup size="sm">
                <label style={{ paddingLeft: "3px" }}>
                In House
                <input
                  name="InHouseFlg"
                  type="checkbox"
                  className="input-checkbox"
                  checked={this.state.searchModel.InHouseFlg}
                  onChange={this.handleSearchChange}
                />
              </label>
              <input
                name="StartDate"
                type="date"
                className="form-control form-control-text"
                value={this.state.searchModel.StartDate}
                onChange={this.handleSearchChange}
                placeholder="StartDate"
                onKeyDown={this.handleKeyDown}
              />

              <input
                name="EndDate"
                type="date"
                className="form-control form-control-text"
                value={this.state.searchModel.EndDate}
                onChange={this.handleSearchChange}
                placeholder="EndDate"
                onKeyDown={this.handleKeyDown}
              />
              <input
                name="StartCheckNumber"
                type="text"
                className="form-control form-control-text"
                value={this.state.searchModel.StartCheckNumber}
                onChange={this.handleSearchChange}
                placeholder="Start Check Number"
                onKeyDown={this.handleKeyDown}
              />
            </InputGroup>
          </Col>
          <Col>
            <InputGroup size="sm">
              {" "}
              <span style={{ paddingRight: "4px" }}></span>
              <Button
                color="secondary"
                className="btn"
                size="sm"
                outline
                onClick={this.exportEDD1099TXT}
              >
                Export EDD Report
              </Button>{" "}
              <span style={{ paddingRight: "4px" }}></span>
              <Button
                color="secondary"
                className="btn"
                size="sm"
                outline
                onClick={this.exportELANachaTXT}
              >
                Export ELANacha
              </Button>{" "}
              <span style={{ paddingRight: "4px" }}></span>
              <Button
                color="secondary"
                className="btn"
                size="sm"
                outline
                onClick={this.exportPayPal}
              >
                Export PayPal
              </Button>{" "}
              <span style={{ paddingRight: "4px" }}></span>
              <Button
                color="secondary"
                className="btn"
                size="sm"
                outline
                onClick={this.printPhysicalCheck}
              >
                Print Physical Checks
              </Button>
              {" "}
              <span style={{ paddingRight: "4px" }}></span>
              <Button
                color="secondary"
                className="btn"
                size="sm"
                outline
                onClick={this.exportInHousePayment}
              >
                Export InHouse Payment
              </Button>
              {" "}
              <span style={{ paddingRight: "4px" }}></span>
              <Button
                color="secondary"
                className="btn"
                size="sm"
                outline
                onClick={this.sendInterpreterPaymentNotifications}
              >
                Interpreter Payment Notification
              </Button>
              <label style={{ paddingLeft: "3px" }}>
                <input
                  name="CommitToDB"
                  type="checkbox"
                  className="input-checkbox"
                  checked={this.state.searchModel.CommitToDB}
                  onChange={this.handleSearchChange}
                />
                Commit To DB
              </label>
            </InputGroup>
          </Col>
        </Row>
        <hr />

        <LoadingModal fetchingData={this.state.fetchingData} />

        <div>{contents}</div>
        <Row>
        <Col>
          <InputGroup size="sm">
            <p
              style={{
                paddingLeft: '60px',
                paddingTop: '10px',
                fontWeight: 'bold',
              }}
            >
              {this.state.interpreterPaymentList.length}
              {' | Total: $'}
              {this.state.interpreterPaymentList
                .reduce((sum, r) => sum + (r.jobTotal || 0), 0)
                .toFixed(2)}
            </p>
          </InputGroup>
        </Col>
      </Row>
      </div>
    );
  }
}
